import axios from 'axios';
import { ADD_USER } from '../../constants';

export const createUser = (data, navigate, onError) => (dispatch) => {
  dispatch(addUser());
  axios
    .post(`admin/createUser`, data)
    .then((res) => {
      dispatch(setUser(res));
      navigate(-1);
    })
    .catch((err) => {
      dispatch(errorUser(err.response));
      onError(err.response);
    });
};

export const addUser = () => ({
  type: ADD_USER.LOAD
});

export const setUser = (data) => ({
  type: ADD_USER.SUCCESS,
  payload: data.data
});

export const errorUser = (error) => ({
  type: ADD_USER.FAIL,
  payload: error
});
